import React from 'react'

import HelpSkillCategoryCard from './HelpSkillCategoryCard'
import { getJobProfileSkillCategories } from './jobProfileSkillsData'

const HelpJobProfileSkills = ({ language }) => (
  <div className="HelpJobProfileSkills">
    {getJobProfileSkillCategories(language).map(({ category, skills }) => (
      <HelpSkillCategoryCard
        key={category}
        category={category}
        skills={skills}
      />
    ))}
  </div>
)

export default HelpJobProfileSkills
